import React from 'react'

/**
 * Lightweight inline-SVG icon set (no icon-library dependency). Each icon
 * inherits `currentColor` and accepts a className so callers control size +
 * colour with Tailwind. Stroke-based, 24x24 viewBox, 1.8 stroke width to match
 * the app's clean/rounded look.
 */
function Svg({ className = 'w-6 h-6', children }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}

export function RadarIcon({ className }) {
  return (
    <Svg className={className}>
      <path d="M19.07 4.93A10 10 0 1 0 22 12" />
      <path d="M16.24 7.76A6 6 0 1 0 18 12" />
      <path d="M12 12 22 2" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
    </Svg>
  )
}

export function FilterIcon({ className }) {
  return (
    <Svg className={className}>
      <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
    </Svg>
  )
}

export function MailIcon({ className }) {
  return (
    <Svg className={className}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </Svg>
  )
}

export function CheckIcon({ className }) {
  return (
    <Svg className={className}>
      <path d="M20 6 9 17l-5-5" />
    </Svg>
  )
}

export function ClockIcon({ className }) {
  return (
    <Svg className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </Svg>
  )
}

export function ShieldIcon({ className }) {
  return (
    <Svg className={className}>
      <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
      <path d="m9 12 2 2 4-4" />
    </Svg>
  )
}

export function BoltIcon({ className }) {
  return (
    <Svg className={className}>
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
    </Svg>
  )
}

export function UsersIcon({ className }) {
  return (
    <Svg className={className}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
      <path d="M16 5.2a3.2 3.2 0 0 1 0 5.6" />
      <path d="M17.5 14.4A5.5 5.5 0 0 1 20.5 20" />
    </Svg>
  )
}
